import { render, staticRenderFns } from "./avaliacoesTecnicos.vue?vue&type=template&id=c3450b2c"
import script from "./avaliacoesTecnicos.vue?vue&type=script&lang=js"
export * from "./avaliacoesTecnicos.vue?vue&type=script&lang=js"
import style0 from "./avaliacoesTecnicos.vue?vue&type=style&index=0&id=c3450b2c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports